import { MRT_DensityState } from 'material-react-table';
import { ReactNode } from 'react';

enum FontFamily {
    INTER = `'Inter', sans-serif`,
    POPPINS = `'Poppins', sans-serif`,
    ROBOTO = `'Roboto', sans-serif`,
    PUBLIC_SANS = `'Public Sans', sans-serif`,
    MAVEN_PRO = `'Maven Pro', sans-serif`,
}

enum PresetColor {
    DEFAULT = 'default',
    THEME1 = 'theme1',
    THEME2 = 'theme2',
    THEME3 = 'theme3',
    THEME4 = 'theme4',
    THEME5 = 'theme5',
    THEME6 = 'theme6',
    THEME7 = 'theme7',
    THEME8 = 'theme8',
    EFP = 'efp',
}

type I18n = 'en' | 'fr' | 'ro' | 'zh';

type FirstStart = true | false;

enum ThemeMode {
    LIGHT = 'light',
    DARK = 'dark',
}

enum MenuOrientation {
    VERTICAL = 'vertical',
    HORIZONTAL = 'horizontal',
}

enum ThemeDirection {
    LTR = 'ltr',
    RTL = 'rtl',
}

type CustomizationActionProps = {
    type: string;
    payload?: CustomizationProps;
};

type DefaultConfigProps = {
    fontFamily: FontFamily;
    i18n: I18n;
    menuOrientation: MenuOrientation;
    miniDrawer: boolean;
    container: boolean;
    showGuide: boolean;
    mode: ThemeMode;
    presetColor: PresetColor;
    themeDirection: ThemeDirection;
    firstStart: FirstStart;
    tableOptions: { density: MRT_DensityState | undefined };
    workflowExecutionTab: TabType;
};

type ConfigProviderProps = {
    children: ReactNode;
};

type TabType = 'Details' | 'Progress';

type CustomizationProps = {
    fontFamily: FontFamily;
    i18n: I18n;
    miniDrawer: boolean;
    showGuide: boolean;
    container: boolean;
    menuOrientation: MenuOrientation;
    mode: ThemeMode;
    presetColor: PresetColor;
    themeDirection: ThemeDirection;
    firstStart: FirstStart;
    tableOptions: { density: MRT_DensityState | undefined };
    workflowExecutionTab: TabType;
    onChangeContainer: VoidFunction;
    onChangeLocalization: (lang: I18n) => void;
    onChangeMode: (mode: ThemeMode) => void;
    onChangePresetColor: (theme: PresetColor) => void;
    onChangeDirection: (direction: ThemeDirection) => void;
    onChangeMiniDrawer: (miniDrawer: boolean) => void;
    onChangeMenuOrientation: (menuOrientation: MenuOrientation) => void;
    onChangeFontFamily: (fontFamily: FontFamily) => void;
    onChangeFirstStart: (firstStart: FirstStart) => void;
    onChangeShowGuide: (showGuide: boolean) => void;
    onChangeTableOptions: (tableOptions: object) => void;
    onChangeWorkflowExecutionTab: (tab: TabType) => void;
};

export type {
    CustomizationProps,
    CustomizationActionProps,
    DefaultConfigProps,
    ConfigProviderProps,
    I18n,
    FirstStart,
    TabType,
};

export { ThemeDirection, ThemeMode, MenuOrientation, FontFamily, PresetColor };
